import { render } from "./Contatti.vue?vue&type=template&id=cb72ade8&ts=true"
import script from "./Contatti.vue?vue&type=script&lang=ts"
export * from "./Contatti.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__